// extracted by mini-css-extract-plugin
export default {"relativeWrapper":"OnikjSS3zmOYGTNvTZE7","imageWrapper":"jJqP71YVfx4uT932o8JA","imageLoader":"pOMNLTExULavbDbJWzh4","hiddenEl":"q9czgZwYbOx4yVuUxc1J"};